import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Button, Col, Row, Collapse,
} from 'antd';
import Moment from 'react-moment';
import { createBikeHpiCheckRequest, getBikeHpiCheckRequest } from '../../redux/actions/bike_hpi_check.actions';
import Finance from './HPI_components/finance';
import NMR from './HPI_components/nmr';
import Stolen from './HPI_components/stolen';
import HighRisk from './HPI_components/highRisk';
import PlateTransfer from './HPI_components/plateTransfer';
import Table from '../../../../../components/table/Table';
import { PlateIcon } from '../../../../../components/icons/plate-icon';
import Damaged from './HPI_components/damaged';


const { Panel } = Collapse;

const mapStateToProps = (state) => {
    const { bike_hpi_check } = state.Leads.Lead_profile.Lead_general;
    const { bike_details } = state.Leads.Lead_profile.Ref_bike_lead;
    return { bike_details, bike_hpi_check };
};

export default connect(mapStateToProps, { createBikeHpiCheckRequest, getBikeHpiCheckRequest })(
    class HpiCheckModal extends Component {
        // you need to send this requests:
        // bike_id take from this.props.lead_profile._id
        // createBikeHpiCheckRequest for add new hpi check with bike_id in param
        // getBikeHpiCheckRequest for read existing one hpi check with bike_id in param
        // e.x. this.props.createBikeHpiCheckRequest(this.props.lead_profile._id)
        state = {
            hideButton: false,
        };

        componentDidMount() {
            const { bike_details, isHpiCheckApproval } = this.props;

            if (bike_details && !isHpiCheckApproval) {
                this.props.getBikeHpiCheckRequest(this.props.bike_details._id);
            }
        }

        createHPICheck = () => {
            if (this.props.bike_details) {
                this.props.createBikeHpiCheckRequest(this.props.bike_details._id);
                this.setState({ hideButton: true });
            }
        };

        render() {
            if (this.props.bike_hpi_check) {
                return (
                    <div className="hpiCheck">
                        <Row className="hpiHeader" gutter={20}>
                            <Col xs={4}>
                                <span className="heading">VRM (Registration)</span>
                                <div className="hpiHeader_inputVrmContainer">
                                    <span className="hpiHeader_inputVrmIcon">
                                        <PlateIcon style={{ height: 40 }} />
                                    </span>
                                    <div className="hpiHeader_input hpiHeader_inputVrm">{this.props.bike_hpi_check.asset_id}</div>
                                </div>
                            </Col>
                            <Col xs={6}>
                                <span className="heading">VIN/Chassis Number</span>
                                <div className="hpiHeader_input hpiHeader_inputVin">
                                    {
                                        this.props.bike_hpi_check.chassis_number
                                        || this.props.bike_hpi_check.bike.chassis_number
                                        || (this.props.bike_details && this.props.bike_details.chassis_number)
                                    }
                                </div>
                            </Col>
                            <Col xs={3}>
                                <span className="heading">Mileage</span>
                                <div className="hpiHeader_input hpiHeader_inputMileage">{this.props.bike_hpi_check.mileage}</div>
                            </Col>
                            {
                                !this.props.hideRerunHpiCheckForApproval
                                && (
                                    <Col xs={4}>
                                        <Button style={{ fontSize: 16, height: 40, marginTop: 26 }} type="primary" onClick={this.createHPICheck} disabled={this.state.hideButton}>Re-Run HPI Check</Button>
                                    </Col>
                                )
                            }
                        </Row>
                        <Row className="hpiBody">
                            <Col>
                                <small style={{ marginRight: 10 }}>
                                    Last Updated:
                                    {this.props.bike_hpi_check.created_date}
                                </small>
                                <strong>
                                    {this.props.bike_hpi_check.bike.colour}
                                    {' '}
                                    {this.props.bike_hpi_check.bike.make}
                                    {' '}
                                    {this.props.bike_hpi_check.bike.model}
                                    {' '}
                                    {this.props.bike_hpi_check.bike.manufacture_date}
                                </strong>
                            </Col>
                            <Col className="passCheck clearfix">
                                <div className={this.props.bike_hpi_check.pass_checks.vehicle_id
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.vehicle_id
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">Vehicle Id</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.colour_change
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.colour_change
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">Colour Change</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.exported
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.exported
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">Exported</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.imported
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.imported
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">Imported</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.high_risk
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.high_risk
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">High Risk</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.thefts
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.thefts
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">Stolen</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.finance
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.finance
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">Finance Agreements</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.scrapped
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.scrapped
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">Scrapped</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.plate_transfer
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.plate_transfer
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">Plate Transfer</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.v5_check
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.v5_check
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">V5</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.nmr
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.nmr
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">NMR</span>
                                </div>
                                <div className={this.props.bike_hpi_check.pass_checks.damaged
                                    ? 'hpiCard'
                                    : 'hpiCard fail'}
                                >
                                    <span className={this.props.bike_hpi_check.pass_checks.damaged
                                        ? 'fa fa-check'
                                        : 'fa fa-times'}
                                    />
                                    <span className="text">Damaged</span>
                                </div>
                            </Col>

                            <Col style={{ marginTop: 10, marginBottom: 10, textAlign: 'center' }}>
                                {
                                    this.props.bike_hpi_check.pass_checks.detail.length > 0
                                    && <div className="failDetail">There is one or more problems with this bike - see below.</div>
                                }
                            </Col>
                            <Col>
                                <Collapse>
                                    <Panel header="Vehicle Id" key="1">
                                        <Table responsive className="table--bordered hpi">
                                            <tbody>
                                                <tr>
                                                    <th>Make</th>
                                                    <td>{this.props.bike_hpi_check.bike.make}</td>
                                                    <th>Model</th>
                                                    <td>{this.props.bike_hpi_check.bike.model}</td>
                                                    <th>Engine Size</th>
                                                    <td>
                                                        {this.props.bike_hpi_check.bike.engine_size}
                                                        cc
                                                    </td>
                                                    <th>Engine Number</th>
                                                    <td>{this.props.bike_hpi_check.bike.engine_number}</td>
                                                </tr>
                                                <tr>
                                                    <th>Colour</th>
                                                    <td>{this.props.bike_hpi_check.bike.colour}</td>
                                                    <th>Door Plan</th>
                                                    <td>{this.props.bike_hpi_check.bike.door_plan}</td>
                                                    <th>Registration Date</th>
                                                    <td><Moment format="D-MM-YYYY">{this.props.bike_hpi_check.bike.uk_date_first_registered}</Moment></td>
                                                    <th>Manufacture Date</th>
                                                    <td>{this.props.bike_hpi_check.bike.manufacture_date}</td>
                                                </tr>
                                                <tr>
                                                    <th>Transmission</th>
                                                    <td>{this.props.bike_hpi_check.bike.transmission}</td>
                                                    <th>Fuel Type</th>
                                                    <td>
                                                        {this.props.bike_hpi_check.bike.fuel_type
                                                            ? this.props.bike_hpi_check.bike.fuel_type
                                                            : 'UNKNOWN'}
                                                    </td>
                                                    <th>CO2 Rating</th>
                                                    <td>
                                                        {this.props.bike_hpi_check.bike.co2_rating !== '000'
                                                            ? this.props.bike_hpi_check.bike.co2_rating
                                                            : 'UNKNOWN'}
                                                    </td>
                                                    <th>Wheel Plan</th>
                                                    <td>
                                                        {this.props.bike_hpi_check.bike.wheel_plan
                                                            ? this.props.bike_hpi_check.bike.wheel_plan
                                                            : 'UNKNOWN'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Gross Weight</th>
                                                    <td>{this.props.bike_hpi_check.bike.gross_vehicle_weight}</td>
                                                    <th>Exported</th>
                                                    <td className={this.props.bike_hpi_check.bike.is_bike_exported ? 'redHPI' : 'green'}>
                                                        {this.props.bike_hpi_check.bike.is_bike_exported
                                                            ? 'YES'
                                                            : 'NO'}
                                                    </td>
                                                    <th>Imported</th>
                                                    <td className={this.props.bike_hpi_check.bike.is_bike_imported ? 'redHPI' : 'green'}>
                                                        {this.props.bike_hpi_check.bike.is_bike_imported
                                                            ? 'YES'
                                                            : 'NO'}
                                                    </td>
                                                    <th>Marked for Scrap</th>
                                                    <td className={this.props.bike_hpi_check.bike.marked_for_scrap ? 'redHPI' : 'green'}>
                                                        {this.props.bike_hpi_check.bike.marked_for_scrap
                                                            ? 'YES'
                                                            : 'NO'}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Panel>
                                    <Panel header="Colour Change" key="2">
                                        <Row>
                                            <Col>
                                                {this.props.bike_hpi_check.previous_colours.has_changed_colour
                                                    ? (
                                                        <p>
                                                            There was a colour change to
                                                            {this.props.bike_hpi_check.previous_colours.colour}
                                                            {' '}
                                                            on
                                                            {this.props.bike_hpi_check.previous_colours.change_date}
                                                        </p>
                                                    )
                                                    : <p>There has been no colour change on this bike</p>}
                                            </Col>
                                        </Row>
                                    </Panel>
                                    <Panel header="High Risk" key="3">
                                        <HighRisk details={this.props.bike_hpi_check.high_risk_list} />
                                    </Panel>
                                    <Panel header="Stolen" key="4">
                                        <Stolen details={this.props.bike_hpi_check.stolen_incidents} />
                                    </Panel>
                                    <Panel header="Finance Agreements" key="5">
                                        <Finance details={this.props.bike_hpi_check.finance_agreements} />
                                    </Panel>
                                    <Panel header="Plate Transfer" key="6">
                                        <PlateTransfer details={this.props.bike_hpi_check.plate_transfer} />
                                    </Panel>
                                    <Panel header="V5" key="7">
                                        <Table responsive className="table--bordered hpi">
                                            <tbody>
                                                <tr>
                                                    <th style={{ width: '20%' }}>Certification Date</th>
                                                    <td>
                                                        {Array.isArray(this.props.bike_hpi_check.cerification_data) && this.props.bike_hpi_check.cerification_data.length > 0
                                                            ? this.props.bike_hpi_check.cerification_data[0].certificate_date
                                                            : 'UNKNOWN'}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Panel>
                                    <Panel header="NMR" key="8">
                                        <NMR details={this.props.bike_hpi_check.mileage_data} />
                                    </Panel>
                                    <Panel header="Damaged" key="9">
                                        <Damaged details={this.props.bike_hpi_check.damage_list} />
                                    </Panel>
                                </Collapse>
                            </Col>
                        </Row>
                    </div>
                );
            }
            return (
                <div>
                    <p>Click the button below to run a HPI check against this vehicle</p>
                    <Button type="primary" onClick={this.createHPICheck} disabled={this.state.hideButton}>Run HPI Check</Button>
                </div>
            );
        }
    },
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/HpiCheckModal.js